import React, { useEffect, useState } from 'react';
import { useAdminStore } from '../../../lib/store-admin';
import { InstitutionModal } from './InstitutionModal';
import { Institution } from '../../../lib/supabase';

export const InstitutionList: React.FC = () => {
    const { institutions, isLoading, fetchInstitutions, setSelectedInstitution } = useAdminStore();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedInstitutionForEdit, setSelectedInstitutionForEdit] = useState<Institution | undefined>(undefined);

    useEffect(() => {
        fetchInstitutions();
    }, [fetchInstitutions]);

    const handleEdit = (inst: Institution, e: React.MouseEvent) => {
        e.stopPropagation();
        setSelectedInstitutionForEdit(inst);
        setIsModalOpen(true);
    };

    const handleCreate = () => {
        setSelectedInstitutionForEdit(undefined);
        setIsModalOpen(true);
    };

    const handleCardClick = (inst: Institution) => {
        setSelectedInstitution(inst);
    };

    if (isLoading && institutions.length === 0) {
        return <div className="loading-spinner">Yükleniyor...</div>;
    }

    return (
        <div className="institution-list-view">
            <div className="action-bar">
                <h1>Kurumlar</h1>
                <button className="btn-primary" onClick={handleCreate}>
                    <span className="material-symbols-outlined">add</span>
                    Yeni Kurum Ekle
                </button>
            </div>

            <div className="institutions-grid">
                {institutions.map((inst) => (
                    <div
                        key={inst.id}
                        className={`institution-card ${inst.is_active ? '' : 'inactive'}`}
                        onClick={() => handleCardClick(inst)}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="logo-placeholder">
                            {inst.logo_url ? (
                                <img src={inst.logo_url} alt={inst.name} />
                            ) : (
                                <span className="material-symbols-outlined">image</span>
                            )}
                        </div>
                        <h3>{inst.name}</h3>
                        <div className="card-actions" style={{ marginTop: 'auto', display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                            <span className={`status-badge ${inst.is_active ? 'active' : 'inactive'}`}>
                                {inst.is_active ? 'Aktif' : 'Pasif'}
                            </span>
                            <button
                                onClick={(e) => handleEdit(inst, e)}
                                className="btn-icon"
                                style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px', color: '#6b7280' }}
                            >
                                <span className="material-symbols-outlined">edit</span>
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            {isModalOpen && (
                <InstitutionModal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    institution={selectedInstitutionForEdit}
                />
            )}
        </div>
    );
};
